module.exports = __webpack_public_path__ + "img/productHSE_16.509a1c4f.png";